import {
  useAuthUserRestaurant,
  useGetUnconfirmedProductOfferOrdersCountQuery,
} from '@durma-soft/gros-sdk';

export const UnconfirmedProductOfferOrdersBadge = () => {
  const restaurant = useAuthUserRestaurant();
  const { data } = useGetUnconfirmedProductOfferOrdersCountQuery({
    restaurant_id: restaurant.id,
  });

  if (!data?.count) return null;

  return (
    <span className="ml-auto inline-flex items-center justify-center min-w-5 h-5 px-1.5 text-xs rounded-full bg-primary text-primary-foreground">
      {data.count}
    </span>
  );
};
